import React from "react";
import { Form } from "react-bootstrap";
import { TooltipIcon } from "../../../assets/js/image";
import "./ToolTip.css";

export const ToolTip = (props) => {
  return (
    <Form.Label
      id={props.toolTipId}
      className={`tooltip ${props.customStyles}`}
    >
      {props.label}
      {props.mandate && <span className={props.mandate}>*</span>}
      {props.toolTipText && (
        <span className="tooltiptext">
          <TooltipIcon />
          {props.toolTipText}
        </span>
      )}
    </Form.Label>
  );
};
